import styled from 'styled-components';
import {dFlex, dFlexColumnCenter, flexWrap, justifyCenter} from '../../../../globalVariables/GlobalFlex';

export const emptyState = styled.div`
    flex: 1;
    min-height: 0;
    ${dFlexColumnCenter}
`;

export const emptyVideo = styled.div`
    flex: 0 1 180px;
    min-height: 0;
    aspect-ratio: 1;
    width: auto;
    max-width: 180px;
`;

export const emptyText = styled.p`
    margin: var(--space-lg) 0 0;
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-regular);
    line-height: 1.4;
    color: var(--color-text-default);
    text-align: center;
`;

export const suggestionsWrap = styled.div`
    margin-top: var(--space-xl);
    ${dFlex}
    ${flexWrap}
    ${justifyCenter}
    gap: var(--space-sm);
    max-width: 330px;
`;
